import { render } from "./StoreList.vue?vue&type=template&id=59225c9a&scoped=true&ts=true"
import script from "./StoreList.vue?vue&type=script&lang=ts"
export * from "./StoreList.vue?vue&type=script&lang=ts"

import "./StoreList.vue?vue&type=style&index=0&id=59225c9a&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59225c9a"]])

export default __exports__